'use client';

import dynamic from 'next/dynamic';
import {FiPlay} from 'react-icons/fi';
import {track} from '@/lib/analytics';

const ReactPlayer = dynamic(() => import('react-player'), {ssr: false});

/** YouTube/Vimeo player with click-to-load preview. */
const Video = ({url}: {url?: string}) => {
  if (!url) {
    return null;
  }
  return (
    <div className='relative my-8 overflow-hidden rounded-2xl bg-zinc-100 pt-[56.25%] [&>*]:absolute [&>*]:top-0 [&>*]:left-0'>
      <ReactPlayer
        pip
        light
        playing
        playIcon={<FiPlay className='size-20 fill-white text-white drop-shadow-lg' />}
        src={url}
        playsInline
        previewAriaLabel='Video abspielen'
        onStart={() => track('video_start', {video_url: url})}
        onEnded={() => track('video_complete', {video_url: url})}
        width='100%'
        height='100%'
      />
    </div>
  );
};

export default Video;
